/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

// @material-ui/core components
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Hidden from '@material-ui/core/Hidden';

import Typography from "@material-ui/core/Typography";
import ButtonBase from '@material-ui/core/ButtonBase';

import MailIcon from '@material-ui/icons/Mail';
import DeleteIcon from '@material-ui/icons/Delete';
import LabelMui from '@material-ui/icons/Label';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import InfoIcon from '@material-ui/icons/Info';
import ForumIcon from '@material-ui/icons/Forum';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';


import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import TSText from "components/Forms/TSText";

import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';


import {
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from "reactstrap";

import axios from "axios";

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
  },
}));


function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, nodeType, nodeVal, onTreeClick, ...other } = props;
  

  return (
    <TreeItem
      //onLabelClick={handleClick(nodeType, nodeVal)}
    
      onLabelClick={onTreeClick}
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
    );
  }


  StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
  };
  
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
      //maxWidth: 400,
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        margin:2,
        textAlign: 'center',
          margin: "3px",
          transition: "0.3s",
          display: "inline-block",
          boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
      width: 180,
      height: 140,
      textAlign: 'center',
      margin: "3px",
      transition: "0.3s",
      display: "inline-block",
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
      "&:hover": {
        boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
      }
    },
    cardImg1: {
        width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardImg2: {
        width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "16px",
      marginTop: "10px",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontFamily: '"Sarabun", sans-serif',
      marginBottom: "3px",
      textDecoration: "none"
    },
  });

const TSUser = props => {

  const [value, setValue] = useState((props.value != null) ? props.value : []);
  const [label, setLabel] = useState((props.label != null) ? props.label : '');
  const [isMultiple, setIsMultiple] = useState((props.isMultiple != null) ? props.isMultiple : '');
  const [isShowAll, setIsShowAll] = useState((props.isShowAll != null && props.isShowAll == true) ? '&isShowAll=true' : '');

   const classes = useStyles();
   const [arrMission, setArrMission] = useState([]);
   const [arrUser, setArrUser] = useState([]);
   const [selectedUser, setSelectedUser] = useState([]);
   const [MissionKey, setMissionKey] = useState(0);
   const [GroupWorkKey, setGroupWorkKey] = useState(0);
   const [DepartmentKey, setDepartmentKey] = useState(0);
   const [Keyword, setKeyword] = useState('');
   const [Param, SetParam] = useState('');
    const _color = [{ id: 1, forecolor: 'lightgreen' }, { id: 2, forecolor: '#ffde79' }, { id: 3, forecolor: '#ffabab' }, { id: 0, forecolor: 'white' }, { id: 5, forecolor: '#E67E22' }]

    /*
   useEffect(() => {

    const requestOptions = {
        method: "GET",
    };

        axios.get("/api/v1/mission/")
        .then(
          result => {
              if(result.data.result == 200)
              {
                setArrMission(result.data.data) 
              }
            },
            error => {console.log(error); }
        );  


            

        if (props.value.length > 0){
          setSelectedUser(props.value);
          //console.log(props.value)
        }

    }, [props.value]);
*/
    useEffect(() => {
      axios.get("/api/v1/mission/").then(
        (result) => { if (result.data.result === 200) setArrMission(result.data.data); },
        () => {}
      );
    }, []);

    useEffect(() => {
      // โหลด mission ครั้งเดียว (ย้ายไป useEffect แยกด้านล่างถ้าต้องการ)
      //axios.get("/api/v1/mission/").then(
      //  (result) => { if (result.data.result === 200) setArrMission(result.data.data); },
      //  () => {}
      //);

      // สำคัญ: ซิงก์ selectedUser ให้ตรงกับ props.value ทุกครั้ง—even when empty []
      setSelectedUser(Array.isArray(props.value) ? props.value : []);

      // ถ้าอยาก refresh รายชื่อทางขวาเมื่อเคลียร์ผู้เลือกทั้งหมด:
      if (Array.isArray(props.value) && props.value.length === 0 && Param !== '') {
        axios.get("/api/v1/userview/" + Param + isShowAll).then(
          (result) => { if (result.data.result === 200) setArrUser(result.data.data); },
          () => {}
        );
      }
    }, [props.value]);  // ← สังเกตว่าไม่เช็ค length > 0 แล้ว

    useEffect(() => {
      if(props.isClear ){
        setSelectedUser([]);
        const list = selectedUser;
        //console.log(list);
        if(Param != '')
        {
          axios.get("/api/v1/userview/"+Param+isShowAll)
          .then(
            result => {
                if(result.data.result == 200)
                {
                  setArrUser(result.data.data)
                }
              },
              error => {console.log(error); }
          );  
        }

      }
    }, [props.isClear]);
  

    const handleRemove = (usr) => {

        const list = selectedUser.filter(u => u.userName !== usr);
        setSelectedUser(list);
        //setArrUser([...arrUser, usr])     
        //console.log(Param)
        if(Param != '')
        {
          axios.get("/api/v1/userview/"+Param+isShowAll)
          .then(
            result => {
                if(result.data.result == 200)
                {
                  if(isMultiple){
                    list.map((usr) => { 
                      result.data.data = result.data.data.filter(obj1 => obj1.userName !== usr.userName);
                    })
                  }

                  setArrUser(result.data.data)
                }
              },
              error => {console.log(error); }
          );  

        }


        if (props.onChange) {
          props.onChange(list);
        }
    };

    const handleKeyword = (val) => {
      //e.preventDefault();
      setKeyword(val);
      var param='?FirstName='+val;
      SetParam(param)



      axios.get("/api/v1/userview/"+param+isShowAll)
      .then(
        result => {
            if(result.data.result == 200)
            {
              selectedUser.map((usr) => { 
                result.data.data = result.data.data.filter(obj1 => obj1.userName !== usr.userName);
              })
              setArrUser(result.data.data)
            }
          },
          error => {console.log(error); }
      );  


    };

    const handleClickTree = (type, val) => (e) => {

      //e.preventDefault();
      //console.log(type)
    
      var param = '';

      if(type == 'M')
        param = '?Missionkey='+val;
      else  if(type == 'G')
        param = '?GroupWorkKey='+val;
      else  if(type == 'D')
        param = '?DepartmentKey='+val;
      else  if(type == 'K')
        param = '?FirstName='+val;

      SetParam(param)


      axios.get("/api/v1/userview/"+param+isShowAll)
      .then(
        result => {
            if(result.data.result == 200)
            {
              if(isMultiple){
                selectedUser.map((usr) => { 
                  result.data.data = result.data.data.filter(obj1 => obj1.userName !== usr.userName);
                })
              }

              setArrUser(result.data.data)
            }
          },
          error => {console.log(error); }
      );  

  
    };


    const handleFilterArray = (usr) => (e) => {
      if(isMultiple)
      {
        setSelectedUser([...selectedUser, usr]);
        //console.log([...selectedUser, usr])
        const filteredArr = arrUser.filter(obj1 => obj1.userName !== usr.userName);
        setArrUser(filteredArr)     

        if (props.onChange) {
          props.onChange([...selectedUser, usr]);
        }
      }
      else
      {
        setSelectedUser([usr]);

        if (props.onChange) {
          props.onChange([usr]);
        }
        //console.log([usr])

        //if (props.onClick) {
        //  props.onClick(e);
        //  setValue([usr]);
        //}
      }

 
      if (props.onClick) {
        //props.onClick(e);
        //console.log(selectedUser)
        //setValue(selectedUser);
      }

    };

    const handleSelectAll = () => {
  const newSelected = [...selectedUser, ...arrUser];

  setSelectedUser(newSelected);
  setArrUser([]);  // เคลียร์ฝั่งผู้เลือกได้แล้ว (ตาม logic เดิม)

  if (props.onChange) {
    props.onChange(newSelected);
  }
};

const handleClearAll = async () => {
  setSelectedUser([]);

  if (Param) {
    const result = await axios.get("/api/v1/userview/" + Param + isShowAll);
    if (result.data.result === 200) {
      setArrUser(result.data.data);
    }
  }

  if (props.onChange) {
    props.onChange([]);
  }
};


  function handleChange(e) {
    var val = (e != null ) ? e.value : null;
    if (props.onChange) {
      props.onChange(e);
      setValue(selectedUser);
      //console.log(selectedUser)
    }
  }

  const renderMission = arrMission.map((mission, index) =>
  <StyledTreeItem onTreeClick={handleClickTree('M', mission.missionKey)} nodeType={"M"} nodeVal={mission.missionKey} key={"M"+mission.missionKey.toString()}  nodeId={"M"+mission.missionKey.toString()} labelText={mission.name} labelIcon={MailIcon} >
       
       
       {Array.isArray(mission.groupWork)
        ? mission.groupWork.map((group, index2) => 
          <StyledTreeItem onTreeClick={handleClickTree('G', group.groupWorkKey)}  nodeType={"G"} nodeVal={group.groupWorkKey}  key={"G"+group.groupWorkKey.toString()}  nodeId={"G"+group.groupWorkKey.toString()} labelText={group.name} labelIcon={MailIcon}  >


                  {Array.isArray(group.department)
                    ? group.department.map((dept, index3) => 
                    <Hidden only='xs' key={"D"+dept.departmentKey.toString()}>
                    <StyledTreeItem onTreeClick={handleClickTree('D', dept.departmentKey)}  nodeType={"D"} nodeVal={dept.departmentKey} key={"D"+dept.departmentKey.toString()}  nodeId={"D"+dept.departmentKey.toString()} labelText={dept.name} labelIcon={MailIcon} style={{ paddingLeft: '20px'}} >
                  
                      </StyledTreeItem>
                    </Hidden>
                    )
                    : null
                  }


          </StyledTreeItem>
        )
        : null
      }
  </StyledTreeItem>
  );

  const renderUser = arrUser.map((user, index) =>
      <></>
    );

    const renderSelectedUser = selectedUser.map((usr, index) => {
        var _c = _color.find(c => usr !== null && c.id === usr.attendStatusKey);
        return (
            <ButtonBase key={index} onClick={event => handleRemove(usr.userName)} >
                <Hidden smUp>
                    <Card className={classes.cardXs} style={{ background: (_c != null) ? _c.forecolor : 'white' }}>
                        {/*<i className={"fa fa-window-close"} style={{ color:'red',fontSize: "1.8em", padding:"0px 5px 5px 173px" }}></i>*/}
                        <CardContent style={{ padding: 0 }} >

                            {/* https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400&h=200&dpr=2 */}
                            <img src={'https://e.trangskin.go.th/avatar/' + usr.userName + '.jpg'}
                                className={classes.cardImg1}
                            //style={{ width: 80, height: 80, borderRadius: 80 / 2, objectFit: 'cover', objectPosition: '100% 0' }}
                            //style={{ width: 'auto', height: 'auto', borderRadius: 80 / 2, minHeight:50, minWidth:50, maxHeight: 80, maxWidth: 80, objectFit: 'cover', objectPosition: '100% 0' }}

                            />
                            <Typography variant="body2">{usr.firstName}</Typography>
                            <Typography variant="body2">{usr.lastName}</Typography>
                        </CardContent>

                    </Card>
                </Hidden>
                <Hidden only='xs'>
                    <Card className={classes.cardSm} style={{ background: (_c != null) ? _c.forecolor : 'white' }}>
                        <i className={"fa fa-window-close"} style={{ color: 'red', fontSize: "1.8em", padding: "0px 5px 5px 153px" }}></i>
                        <CardContent style={{ padding: 0 }} >

                            {/* https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400&h=200&dpr=2 */}
                            <img src={'https://e.trangskin.go.th/avatar/' + usr.userName + '.jpg'}
                                className={classes.cardImg2} style={{ marginTop: -20 }}
                            //style={{ width: 80, height: 80, borderRadius: 80 / 2, objectFit: 'cover', objectPosition: '100% 0' }}
                            //style={{ width: 'auto', height: 'auto', borderRadius: 80 / 2, minHeight:50, minWidth:50, maxHeight: 80, maxWidth: 80, objectFit: 'cover', objectPosition: '100% 0' }}

                            />
                            <Typography variant="body2">{usr.firstName + ' ' + usr.lastName}</Typography>
                        </CardContent>

                    </Card>
                </Hidden>
            </ButtonBase>   
           )
        }
    );

  return (
    <Grid>
            
      {(isMultiple && selectedUser.length > 0) ? 
      <Col xs={12} sm={12} md={12}>
      
        <Card>
          <CardHeader color="success">
            <p className={classes.cardCategoryWhite}> เจ้าหน้าที่ที่เลือก</p>
          </CardHeader>
          <CardBody style={{padding:3}}> 
  
            {renderSelectedUser}
        
          </CardBody>
        </Card >             

      </Col>
      :
      <></>
      }
      <Col xs={12} sm={4} md={4}>
          <TreeView
            className={classes.root}
            defaultExpanded={['3']}
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
            defaultEndIcon={<div style={{ width: 24 }} />}
            //onNodeSelect={handleSelect}
          >
            {renderMission}
        </TreeView>
      </Col>
      <Col xs={12} sm={8} md={8} >

        <Card>
          <CardHeader color="primary">
            <p className={classes.cardCategoryWhite}> ค้นหาเจ้าหน้าที่จากชื่อ {Keyword}</p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p className={classes.cardCategoryWhite}>ค้นหาเจ้าหน้าที่จากชื่อ {Keyword}</p>

        <div>
            <button 
                style={{ marginRight: 10 }} 
                className="btn btn-success"
                onClick={handleSelectAll}
            >
                เลือกทั้งหมด
            </button>

            <button 
                className="btn btn-danger"
                onClick={handleClearAll}
            >
                ล้างทั้งหมด
            </button>
        </div>
    </div>
            <TSText label="" value={Keyword} onChange={e => handleKeyword(e.target.value)} />
          </CardHeader>
          <CardBody> 
                {arrUser.map((usr) => (
                  <ButtonBase value={selectedUser} onClick={handleFilterArray(usr)}  >
                  <Hidden smUp>
                 
                  <Card className={classes.cardXs}>
                          <CardContent style={{ padding: 0 }} >
                          <img src={'https://e.trangskin.go.th/avatar/' + usr.userName + '.jpg'}
                                    className={classes.cardImg1}
                                    />
                                    <Typography variant="body2">{usr.firstName}</Typography>
                                    <Typography variant="body2">{usr.lastName}</Typography>
                          </CardContent>
                  
                        </Card>
                  </Hidden>
                  <Hidden only='xs'>
                 
                            <Card className={classes.cardSm} >
                                <CardContent style={{ padding: 0 }} >
                                    <img src={'https://e.trangskin.go.th/avatar/' + usr.userName + '.jpg'}
                                        className={classes.cardImg2} style={{ marginTop: 2 }}
                                    //style={{ width: 80, height: 80, borderRadius: 80 / 2, objectFit: 'cover', objectPosition: '100% 0' }}
                                    //style={{ width: 'auto', height: 'auto', borderRadius: 80 / 2, minHeight:50, minWidth:50, maxHeight: 80, maxWidth: 80, objectFit: 'cover', objectPosition: '100% 0' }}

                                    />
                                    <Typography variant="body2">{usr.firstName + ' ' + usr.lastName}</Typography>
                                    <Typography variant="body2">{(usr.nickName != null && usr.nickName != '') ? '(' + usr.nickName + ')' : ''}</Typography>
                                </CardContent>

                            </Card>
                  </Hidden>
                  </ButtonBase>

            
                ))}
        
          </CardBody>
        </Card >

      </Col>

    </Grid>


  );
}

export default TSUser;
